import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import {
  addCustomerToUserReducer,
  addUserReducer,
  getRoleReducer,
  getUserByIDReducer,
  getUsersReducer,
  userLoginReducer,
  fetchAttendanceReducer,
  removeCustomerFromUserReducer,
  resetDeviceIDReducer,
  resetPasswordReducer,
  updateUserReducer,
  resignUserReducer,
  resignUsersReducer,
  rejoinUserReducer,
  forceLogoutUserReducer,
  forceLogoutMultipleReducer,
  getForceLogoutHistoryReducer,
} from "./reducers/userReducers";
import {
  addCustomerReducer,
  getCustomersReducer,
  updateCustomerReducer,
} from "./reducers/customerReducers";
import {
  addRoleReducer,
  getRoleByIDReducer,
  getRolesReducer,
  updateRoleReducer,
} from "./reducers/roleReducers";
import {
  taskUploadReducer,
  unassignedTasksReducer,
  transferredTasksReducer,
  reassignMultipleTasksReducer,
  collectionUploadReducer,
  getTasksReducer,
  searchTasksReducer,
  getBankTasksReducer,
  getFinalisationTasksReducer,
  getInProgressTasksReducer,
  getTasksIDReducer,
  getTaskIDReducer,
  taskUpdateRemarksReducer,
  taskUpdateSubmitReducer,
  taskCheckedReducer,
  taskFinalisationReducer,
  updateTaskByIDReducer,
  dialReducer,
  getFieldExecutiveTasksReducer,
  waiveTaskReducer,
  getCompletedTasksReducer,
  getJobDoneTasksReducer,
} from "./reducers/taskReducer";
import {
  addPincodeReducer,
  getPincodeReducer,
  editPincodeReducer,
} from "./reducers/pincodeReducers";
import {
  currentAppVersionReducer,
  settingCallingDistanceReducer,
  settingReducer,
} from "./reducers/settingReducers";
import {
  attendanceCountReducer,
  taskCountReducer,
  fieldTaskCountReducer,
  todayTaskCountReducer,
  todayRegionTaskCountReducer,
  todayRegionStatusTaskCountReducer,
  todayCustomerTaskCountReducer,
  fieldTaskCountHourReducer,
  getTasksOneReducer,
  TaskCountHourReducer,
} from "./reducers/countReducers";

import {
  addProcessReducer,
  getProcessesReducer,
  updateProcessReducer,
  deleteProcessReducer,
} from "./reducers/processReducers";
import {
  submitCollectionReducer,
  getMyCollectionsReducer,
  getMyProcessesReducer,
  getMyStatisticsReducer,
  updateCollectionReducer,
  deleteCollectionReducer,
  getProcessDefaultsReducer,
} from "./reducers/dailyCollectionReducers";

import {
  assignProcessesToSupervisorReducer,
  getSupervisorProcessAssignmentsReducer,
  updateSupervisorProcessAssignmentReducer,
  deleteSupervisorProcessAssignmentReducer,
} from "./reducers/assignProcessReducers";

import {
  getAllDailyCollectionsReducer,
  getDailyFlowCollectionsReducer,
  getDailyRecoveryCollectionsReducer,
} from "./reducers/dailyMisReducers";

import {
  getMonthlyCollectionsSummaryReducer,
  getMonthlyFlowCollectionsReducer,
  getMonthlyRecoveryCollectionsReducer,
} from "./reducers/monthlyMisreducers";

import {
  submitMonthlyCollectionReducer,
  getMyMonthlyCollectionsReducer,
  getMyMonthlyStatisticsReducer,
  updateMonthlyCollectionReducer,
  deleteMonthlyCollectionReducer,
} from "./reducers/monthlyCollectionReducers";

import {
  getDelhiRecordsReducer,
  createDelhiRecordReducer,
  updateDelhiRecordReducer,
  deleteDelhiRecordReducer,
  bulkDeleteDelhiRecordsReducer,
  importDelhiRecordsReducer,
  exportDelhiRecordsReducer,
  updateDelhiCellReducer,
} from "./reducers/delhiReducers";

import {
  getHaryanaRecordsReducer,
  importHaryanaRecordsReducer,
  exportHaryanaRecordsReducer,
  updateHaryanaRecordReducer,
  deleteHaryanaRecordReducer,
  bulkDeleteHaryanaRecordsReducer,
} from "./reducers/HaryanaReducer";

import {
  getHdfcCardRecordsReducer,
  createHdfcCardReducer,
  updateHdfcCardReducer,
  deleteHdfcCardReducer,
  bulkDeleteHdfcCardReducer,
  importHdfcCardReducer,
  exportHdfcCardReducer,
} from "./reducers/HdfcCardReducer";

import {
  getHdfcRetailRecordsReducer,
  importHdfcRetailReducer,
  exportHdfcRetailReducer,
  updateHdfcRetailReducer,
  deleteHdfcRetailReducer,
  bulkDeleteHdfcRetailReducer,
} from "./reducers/HdfcRetailReducers";

import {
  getAllUpRecordsReducer,
  importUpRecordsReducer,
  exportUpRecordsReducer,
  updateUpRecordReducer,
  deleteUpRecordReducer,
  bulkDeleteUpRecordsReducer,
} from "./reducers/UpReducers";

import {
  getAllIdfcRecordsReducer,
  importIdfcRecordsReducer,
  exportIdfcRecordsReducer,
  updateIdfcRecordReducer,
  deleteIdfcRecordReducer,
  bulkDeleteIdfcRecordsReducer,
} from "./reducers/IdfcReducers";

import {
  kotakRecordsReducer,
  createKotakRecordReducer,
  updateKotakRecordReducer,
  deleteKotakRecordReducer,
  bulkDeleteKotakRecordsReducer,
  importKotakRecordsReducer,
  exportKotakRecordsReducer,
} from "./reducers/KotakReducers";

import {
  getTataRecordsReducer,
  createTataRecordReducer,
  updateTataRecordReducer,
  deleteTataRecordReducer,
  bulkDeleteTataRecordsReducer,
  importTataRecordsReducer,
  exportTataRecordsReducer,
} from "./reducers/TataReducers";

import {
  submitTatAnalysisReducer,
  getMyTatAnalysisReducer,
  getTatStatisticsReducer,
  updateTatAnalysisReducer,
  deleteTatAnalysisReducer,
  getTatAnalysisReportReducer,
} from "./reducers/tatAnalysisReducer";
import {
  addVerificationProcessReducer,
  getVerificationProcessesReducer,
  updateVerificationProcessReducer,
  deleteVerificationProcessReducer,
} from "./reducers/verificationProcessReducers";

import {
  assignVerificationProcessesToProcessManagerReducer,
  getVerificationProcessAssignmentsReducer,
  updateVerificationProcessAssignmentReducer,
  deleteVerificationProcessAssignmentReducer,
} from "./reducers/verficationAssignProcessReducer";

import {
  getHdfcCardUPRecordsReducer,
  createHdfcCardUPReducer,
  updateHdfcCardUPReducer,
  deleteHdfcCardUPReducer,
  bulkDeleteHdfcCardUPReducer,
  importHdfcCardUPReducer,
  exportHdfcCardUPReducer,
  getHdfcCardUPDepartmentsReducer,
} from "./reducers/hdfcCardUPReducers";

import {
  getHdfcRetailUPRecordsReducer,
  importHdfcRetailUPReducer,
  exportHdfcRetailUPReducer,
  updateHdfcRetailUPReducer,
  deleteHdfcRetailUPReducer,
  bulkDeleteHdfcRetailUPReducer,
} from "./reducers/hdfcRetailUPReducers";

import { prospectReducer } from "./reducers/prospectReducer";

import {
  salaryUploadReducer,
  salaryCreateReducer,
  salaryListReducer,
  salaryDetailsReducer,
  salaryUpdateReducer,
  salaryDeleteReducer,
  salaryBulkDeleteReducer,
  salaryStatsReducer,
  salaryApproveReducer,
  salaryApproveAllReducer,
  salaryHoldReducer,
  salaryGenerateReducer,
} from "./reducers/salaryReducers";

import {
  employeeUploadReducer,
  employeeListReducer,
  employeeCreateReducer,
  employeeUpdateReducer,
  employeeDeleteReducer,
  employeeMarkLeftReducer,
  employeeRejoinReducer,
} from "./reducers/employeeMasterReducers";

import {
  advanceUploadReducer,
  advanceListReducer,
  advanceUpdateReducer,
  advanceDeleteReducer,
  attendanceUploadReducer,
  attendanceListReducer,
  attendanceUpdateReducer,
  attendanceDeleteReducer,
  attendanceStatsReducer,
  bonusUploadReducer,
  bonusListReducer,
  bonusUpdateReducer,
  bonusDeleteReducer,
} from "./reducers/masterReducers";

import {
  companyListReducer,
  companyCreateReducer,
  companyDetailsReducer,
  companyUpdateReducer,
  companyDeleteReducer,
  companyToggleStatusReducer,
  companyStatsReducer,
} from "./reducers/companyReducers";

import {
  supervisorUsersReducer,
  supervisorMasterListReducer,
  supervisorMasterCreateReducer,
  supervisorMasterUpdateReducer,
  supervisorMasterDeleteReducer,
  supervisorMasterUploadReducer,
} from "./reducers/supervisorMasterReducers";

import {
  billingAllRecordsReducer,
  billingSubmitReducer,
  billingBulkUpdateReducer,
  billingSupervisorBanksReducer,
  billingStatusUpdateReducer,
  billingMasterListReducer,
  billingMasterCreateReducer,
  billingMasterUpdateReducer,
  billingMasterDeleteReducer,
  billingMasterBulkDeleteReducer,
} from "./reducers/billingMasterReducers";

import {
  provisionalBillingMyRecordsReducer,
  provisionalBillingSubmitReducer,
  provisionalBillingBulkUpdateReducer,
  provisionalBillingSupervisorBanksReducer,
  provisionalBillingAllRecordsReducer,
} from "./reducers/provisionalBillingReducers";

import {
  invoiceDataAllRecordsReducer,
  invoiceDataCreateReducer,
  invoiceDataUpdateReducer,
  invoiceDataDeleteReducer,
} from "./reducers/invoiceDataReducers";

import {
  distributionSetupReducer,
  distributionMyRecordsReducer,
  distributionSubmitReducer,
  distributionBulkUpdateReducer,
} from "./reducers/distributionReducers";

import { collectionMisReducer, collectionSupervisorsReducer } from "./reducers/collectionMisReducers";
import { consolidatedMisReducer } from "./reducers/consolidatedMisReducers";

const reducer = combineReducers({
  fieldExecutiveTasks: getFieldExecutiveTasksReducer,
  unassignedTasks: unassignedTasksReducer,
  transferredTasks: transferredTasksReducer,
  reassignMultipleTasks: reassignMultipleTasksReducer,
  getTodayCustomerTaskCountInfo: todayCustomerTaskCountReducer,
  getTodayRegionStatusTaskCountInfo: todayRegionStatusTaskCountReducer,
  getTodayRegionTaskCountInfo: todayRegionTaskCountReducer,
  getTaskCountInfo: taskCountReducer,
  getFieldTaskCountInfo: fieldTaskCountReducer,
  getFieldTaskCountHourInfo: fieldTaskCountHourReducer,
  getTaskCountHourInfo: TaskCountHourReducer,
  getTodayTaskCountInfo: todayTaskCountReducer,
  getAttendanceCountInfo: attendanceCountReducer,
  taskUpload: taskUploadReducer,
  collectionUpload: collectionUploadReducer,
  getTasksInfo: getTasksReducer,
  getTasksOneInfo: getTasksOneReducer,
  searchTasksInfo: searchTasksReducer,
  getBankTasksInfo: getBankTasksReducer,
  getFinalisationTasksInfo: getFinalisationTasksReducer,
  getCompletedTasksInfo: getCompletedTasksReducer,
  getJobDoneTasksInfo: getJobDoneTasksReducer,
  getInProgressTasksInfo: getInProgressTasksReducer,
  getTasksIdInfo: getTasksIDReducer,
  getTaskIdInfo: getTaskIDReducer,
  updateTaskByIDInfo: updateTaskByIDReducer,
  taskCheckedInfo: taskCheckedReducer,
  taskUpdateSubmitInfo: taskUpdateSubmitReducer,
  taskUpdateRemarksInfo: taskUpdateRemarksReducer,
  taskFinalisationInfo: taskFinalisationReducer,
  dialInfo: dialReducer,
  addPincodeInfo: addPincodeReducer,
  getPincodeInfo: getPincodeReducer,
  editPincodeInfo: editPincodeReducer,
  userLogin: userLoginReducer,
  getRoleInfo: getRoleReducer,
  getCustomersInfo: getCustomersReducer,
  addCustomerInfo: addCustomerReducer,
  updateCustomerInfo: getCustomersReducer,
  getRolesInfo: getRolesReducer,
  addRoleInfo: addRoleReducer,
  getRoleByIDInfo: getRoleByIDReducer,
  updateRoleInfo: updateRoleReducer,
  getUsersInfo: getUsersReducer,
  addUserInfo: addUserReducer,
  forceLogoutUserInfo: forceLogoutUserReducer,
  forceLogoutMultipleInfo: forceLogoutMultipleReducer,
  forceLogoutHistoryInfo: getForceLogoutHistoryReducer,
  resignUsersInfo: resignUsersReducer,
  resignUserInfo: resignUserReducer,
  rejoinUserInfo: rejoinUserReducer,
  getUserByIDInfo: getUserByIDReducer,
  addCustomerToUserInfo: addCustomerToUserReducer,
  updateUserInfo: updateUserReducer,
  resetDeviceIDInfo: resetDeviceIDReducer,
  resetPasswordInfo: resetPasswordReducer,
  removeCustomerFromUserInfo: removeCustomerFromUserReducer,
  fetchAttendanceInfo: fetchAttendanceReducer,
  settingInfo: settingReducer,
  settingCallingDistanceInfo: settingCallingDistanceReducer,
  currentAppVersionInfo: currentAppVersionReducer,
  waiveTaskInfo: waiveTaskReducer,
  getProcessesInfo: getProcessesReducer,
  addProcessInfo: addProcessReducer,
  updateProcessInfo: updateProcessReducer,
  deleteProcessInfo: deleteProcessReducer,
  submitCollectionInfo: submitCollectionReducer,
  myCollectionsInfo: getMyCollectionsReducer,
  myProcessesInfo: getMyProcessesReducer,
  myStatisticsInfo: getMyStatisticsReducer,
  updateCollectionInfo: updateCollectionReducer,
  deleteCollectionInfo: deleteCollectionReducer,
  assignProcessesInfo: assignProcessesToSupervisorReducer,
  supervisorProcessAssignmentsInfo: getSupervisorProcessAssignmentsReducer,
  updateSupervisorProcessAssignmentInfo:
    updateSupervisorProcessAssignmentReducer,
  deleteSupervisorProcessAssignmentInfo:
    deleteSupervisorProcessAssignmentReducer,
  allDailyCollectionsInfo: getAllDailyCollectionsReducer,
  dailyRecoveryCollectionsInfo: getDailyRecoveryCollectionsReducer,
  dailyFlowCollectionsInfo: getDailyFlowCollectionsReducer,
  monthlyCollectionsSummaryInfo: getMonthlyCollectionsSummaryReducer,
  monthlyRecoveryCollectionsInfo: getMonthlyRecoveryCollectionsReducer,
  monthlyFlowCollectionsInfo: getMonthlyFlowCollectionsReducer,
  getDelhiRecords: getDelhiRecordsReducer,
  createDelhiRecord: createDelhiRecordReducer,
  updateDelhiRecord: updateDelhiRecordReducer,
  deleteDelhiRecord: deleteDelhiRecordReducer,
  bulkDeleteDelhiRecords: bulkDeleteDelhiRecordsReducer,
  importDelhiRecords: importDelhiRecordsReducer,
  exportDelhiRecords: exportDelhiRecordsReducer,
  updateDelhiCell: updateDelhiCellReducer,
  getHaryanaRecords: getHaryanaRecordsReducer,
  importHaryanaRecords: importHaryanaRecordsReducer,
  exportHaryanaRecords: exportHaryanaRecordsReducer,
  updateHaryanaRecord: updateHaryanaRecordReducer,
  deleteHaryanaRecord: deleteHaryanaRecordReducer,
  bulkDeleteHaryanaRecords: bulkDeleteHaryanaRecordsReducer,
  getHdfcCardRecords: getHdfcCardRecordsReducer,
  createHdfcCard: createHdfcCardReducer,
  updateHdfcCard: updateHdfcCardReducer,
  deleteHdfcCard: deleteHdfcCardReducer,
  bulkDeleteHdfcCard: bulkDeleteHdfcCardReducer,
  importHdfcCard: importHdfcCardReducer,
  exportHdfcCard: exportHdfcCardReducer,
  getHdfcRetailRecords: getHdfcRetailRecordsReducer,
  importHdfcRetail: importHdfcRetailReducer,
  exportHdfcRetail: exportHdfcRetailReducer,
  updateHdfcRetail: updateHdfcRetailReducer,
  deleteHdfcRetail: deleteHdfcRetailReducer,
  bulkDeleteHdfcRetail: bulkDeleteHdfcRetailReducer,
  getAllUpRecords: getAllUpRecordsReducer,
  importUpRecords: importUpRecordsReducer,
  exportUpRecords: exportUpRecordsReducer,
  updateUpRecord: updateUpRecordReducer,
  deleteUpRecord: deleteUpRecordReducer,
  bulkDeleteUpRecords: bulkDeleteUpRecordsReducer,
  getAllIdfcRecords: getAllIdfcRecordsReducer,
  importIdfcRecords: importIdfcRecordsReducer,
  exportIdfcRecords: exportIdfcRecordsReducer,
  updateIdfcRecord: updateIdfcRecordReducer,
  deleteIdfcRecord: deleteIdfcRecordReducer,
  bulkDeleteIdfcRecords: bulkDeleteIdfcRecordsReducer,
  kotakRecords: kotakRecordsReducer,
  createKotakRecord: createKotakRecordReducer,
  updateKotakRecord: updateKotakRecordReducer,
  deleteKotakRecord: deleteKotakRecordReducer,
  bulkDeleteKotakRecords: bulkDeleteKotakRecordsReducer,
  importKotakRecords: importKotakRecordsReducer,
  exportKotakRecords: exportKotakRecordsReducer,
  getTataRecords: getTataRecordsReducer,
  createTataRecord: createTataRecordReducer,
  updateTataRecord: updateTataRecordReducer,
  deleteTataRecord: deleteTataRecordReducer,
  bulkDeleteTataRecords: bulkDeleteTataRecordsReducer,
  importTataRecords: importTataRecordsReducer,
  exportTataRecords: exportTataRecordsReducer,
  processDefaultsInfo: getProcessDefaultsReducer,
  submitMonthlyCollectionInfo: submitMonthlyCollectionReducer,
  myMonthlyCollectionsInfo: getMyMonthlyCollectionsReducer,
  myMonthlyStatisticsInfo: getMyMonthlyStatisticsReducer,
  updateMonthlyCollectionInfo: updateMonthlyCollectionReducer,
  deleteMonthlyCollectionInfo: deleteMonthlyCollectionReducer,
  submitTatAnalysisInfo: submitTatAnalysisReducer,
  myTatAnalysisInfo: getMyTatAnalysisReducer,
  tatStatisticsInfo: getTatStatisticsReducer,
  updateTatAnalysisInfo: updateTatAnalysisReducer,
  deleteTatAnalysisInfo: deleteTatAnalysisReducer,
  getVerificationProcessesInfo: getVerificationProcessesReducer,
  addVerificationProcessInfo: addVerificationProcessReducer,
  updateVerificationProcessInfo: updateVerificationProcessReducer,
  deleteVerificationProcessInfo: deleteVerificationProcessReducer,
  assignVerificationProcessesInfo:
    assignVerificationProcessesToProcessManagerReducer,
  verificationProcessAssignmentsInfo: getVerificationProcessAssignmentsReducer,
  updateVerificationProcessAssignmentInfo:
    updateVerificationProcessAssignmentReducer,
  deleteVerificationProcessAssignmentInfo:
    deleteVerificationProcessAssignmentReducer,
  tatAnalysisReportInfo: getTatAnalysisReportReducer,
  getHdfcCardUPRecords: getHdfcCardUPRecordsReducer,
  createHdfcCardUP: createHdfcCardUPReducer,
  updateHdfcCardUP: updateHdfcCardUPReducer,
  deleteHdfcCardUP: deleteHdfcCardUPReducer,
  bulkDeleteHdfcCardUP: bulkDeleteHdfcCardUPReducer,
  importHdfcCardUP: importHdfcCardUPReducer,
  exportHdfcCardUP: exportHdfcCardUPReducer,
  getHdfcCardUPDepartments: getHdfcCardUPDepartmentsReducer,
  getHdfcRetailUPRecords: getHdfcRetailUPRecordsReducer,
  importHdfcRetailUP: importHdfcRetailUPReducer,
  exportHdfcRetailUP: exportHdfcRetailUPReducer,
  updateHdfcRetailUP: updateHdfcRetailUPReducer,
  deleteHdfcRetailUP: deleteHdfcRetailUPReducer,
  bulkDeleteHdfcRetailUP: bulkDeleteHdfcRetailUPReducer,
  prospect: prospectReducer,
  salaryUpload: salaryUploadReducer,
  salaryCreate: salaryCreateReducer,
  salaryList: salaryListReducer,
  salaryDetails: salaryDetailsReducer,
  salaryUpdate: salaryUpdateReducer,
  salaryDelete: salaryDeleteReducer,
  salaryBulkDelete: salaryBulkDeleteReducer,
  salaryStats: salaryStatsReducer,
  salaryApprove: salaryApproveReducer,
  salaryApproveAll: salaryApproveAllReducer,
  salaryHold: salaryHoldReducer,
  advanceUpload: advanceUploadReducer,
  advanceList: advanceListReducer,
  advanceUpdate: advanceUpdateReducer,
  advanceDelete: advanceDeleteReducer,
  attendanceUpload: attendanceUploadReducer,
  attendanceList: attendanceListReducer,
  attendanceUpdate: attendanceUpdateReducer,
  attendanceDelete: attendanceDeleteReducer,
  attendanceStats: attendanceStatsReducer,
  bonusUpload: bonusUploadReducer,
  bonusList: bonusListReducer,
  bonusUpdate: bonusUpdateReducer,
  bonusDelete: bonusDeleteReducer,
  companyList: companyListReducer,
  companyCreate: companyCreateReducer,
  companyDetails: companyDetailsReducer,
  companyUpdate: companyUpdateReducer,
  companyDelete: companyDeleteReducer,
  companyToggleStatus: companyToggleStatusReducer,
  companyStats: companyStatsReducer,
  salaryGenerate: salaryGenerateReducer,
  employeeUpload: employeeUploadReducer,
  employeeList: employeeListReducer,
  employeeCreate: employeeCreateReducer,
  employeeUpdate: employeeUpdateReducer,
  employeeDelete: employeeDeleteReducer,
  employeeMarkLeft: employeeMarkLeftReducer,
  employeeRejoin: employeeRejoinReducer,
  supervisorUsers: supervisorUsersReducer,
  supervisorMasterList: supervisorMasterListReducer,
  supervisorMasterCreate: supervisorMasterCreateReducer,
  supervisorMasterUpdate: supervisorMasterUpdateReducer,
  supervisorMasterDelete: supervisorMasterDeleteReducer,
  supervisorMasterUpload: supervisorMasterUploadReducer,
  billingAllRecords: billingAllRecordsReducer,
  billingSubmit: billingSubmitReducer,
  billingBulkUpdate: billingBulkUpdateReducer,
  billingSupervisorBanks: billingSupervisorBanksReducer,
  billingStatusUpdate: billingStatusUpdateReducer,
  billingMasterList: billingMasterListReducer,
  billingMasterCreate: billingMasterCreateReducer,
  billingMasterUpdate: billingMasterUpdateReducer,
  billingMasterDelete: billingMasterDeleteReducer,
  billingMasterBulkDelete: billingMasterBulkDeleteReducer,
  provisionalBillingMyRecords: provisionalBillingMyRecordsReducer,
  provisionalBillingSubmit: provisionalBillingSubmitReducer,
  provisionalBillingBulkUpdate: provisionalBillingBulkUpdateReducer,
  provisionalBillingSupervisorBanks: provisionalBillingSupervisorBanksReducer,
  provisionalBillingAllRecords: provisionalBillingAllRecordsReducer,
  invoiceDataAllRecords: invoiceDataAllRecordsReducer,
  invoiceDataCreate: invoiceDataCreateReducer,
  invoiceDataUpdate: invoiceDataUpdateReducer,
  invoiceDataDelete: invoiceDataDeleteReducer,
  distributionSetup: distributionSetupReducer,
  distributionMyRecords: distributionMyRecordsReducer,
  distributionSubmit: distributionSubmitReducer,
  distributionBulkUpdate: distributionBulkUpdateReducer,
  collectionMis: collectionMisReducer,
  collectionSupervisors: collectionSupervisorsReducer,
  consolidatedMis: consolidatedMisReducer,
});

const userInfoFromStorage = localStorage.getItem("userInfo")
  ? JSON.parse(localStorage.getItem("userInfo"))
  : null;

const inititalState = {
  userLogin: { userInfo: userInfoFromStorage },
};

const middleware = [thunk];

// Conditionally apply Redux DevTools extension
const composeEnhancers =
  process.env.NODE_ENV === "development"
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    : compose;

const store = createStore(
  reducer,
  inititalState,
  composeEnhancers(applyMiddleware(...middleware)),
);

export default store;
